<template>
  <section class="va-upsell-card">
    <div class="va-upsell-card-text">
      <span class="va-upsell-card-title">Use todas as ferramentas do Vet Alfa</span>
      <span class="va-upsell-card-subtitle"
        >Assine quando quiser e cancele a qualquer momento.</span
      >
    </div>
    <button type="button" class="va-upsell-card-button" @click="$emit('select')">
      Assinar agora
    </button>
  </section>
</template>

<style>
.va-upsell-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 14px;
  color: #ffffff;
  background: linear-gradient(90deg, #002f56 0%, #00728a 100%);
}

.va-upsell-card-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.va-upsell-card-title {
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: #ffffff;
}

.va-upsell-card-subtitle {
  font-size: 13px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.85);
}

.va-upsell-card-button {
  height: 44px;
  width: 100%;
  border: none;
  border-radius: 10px;
  background: #ffffff;
  color: #193153;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.va-upsell-card-button:hover {
  background: #f5f6fa;
}
</style>

<script>
export default {
  name: "HomeUpsellCard",
};
</script>
